import { graphql } from "gatsby"
import MarkdownContent from "components/MarkdownContent"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"

function PageMarkdown({ heading, content, compact }) {
  // Support both Contentful (htmlAst) and local YAML (raw markdown string)
  const htmlAst = content?.childMarkdownRemark?.htmlAst
  const fallbackHtml = content?.childMarkdownRemark?.html
  // For local YAML, content might be raw markdown that needs ReactMarkdown processing
  const rawMarkdown = !htmlAst ? fallbackHtml : null

  return (
    <Container section>
      {heading && (
        <div
          className={
            compact
              ? "mb-4 mt-12 lg:mb-6 lg:mt-16"
              : "mb-10 mt-32 lg:mb-20 lg:mt-48"
          }
        >
          <Heading title={heading} />
        </div>
      )}
      {content && (
        <MarkdownContent
          className="prose prose-dark-grey"
          htmlAst={htmlAst}
          rawMarkdownBody={rawMarkdown}
        />
      )}
    </Container>
  )
}

export default PageMarkdown

export const query = graphql`
  fragment PageMarkdown on ContentfulPageMarkdown {
    id
    __typename
    heading
    content {
      childMarkdownRemark {
        htmlAst
        html
      }
    }
  }
`
